import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { GiMuscleUp } from "react-icons/gi";
import { GiLeg } from "react-icons/gi";
import { FaRunning } from "react-icons/fa";
import { calculateResults } from "../utils/trainingResultsCalculations";
import { formatScore } from "../utils/formatting";
// import { useTheme } from "@mui/material";

const MonthlySummary = ({ monthlyTransactions }) => {
  const { upperBody, lowerBody, cardio } =
    calculateResults(monthlyTransactions);
  return (
    <Grid container spacing={{ xs: 1, sm: 2 }} mb={2}>
      {/* 上半身 */}
      <Grid
        size={{ xs: 4 }}
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Card
          sx={{
            bgcolor: (theme) => theme.palette.upperBody.main,
            color: "white",
            borderRadius: "10px",
            flexGrow: 1,
          }}
        >
          <CardContent sx={{ padding: { xs: 1, sm: 2 } }}>
            <Stack direction={"row"}>
              <GiMuscleUp />
              <Typography>上半身</Typography>
            </Stack>
            <Typography
              variant="h5"
              sx={{
                textAlign: "right",
                fontWeight: "fontWeightBold",
                wordBreak: "break-word",
                fontSize: { xs: ".8rem", sm: "1rem", md: "1.2rem" },
              }}
            >
              {formatScore(upperBody)}pt
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      {/* 下半身 */}
      <Grid
        size={{ xs: 4 }}
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Card
          sx={{
            bgcolor: (theme) => theme.palette.lowerBody.main,
            color: "white",
            borderRadius: "10px",
            flexGrow: 1,
          }}
        >
          <CardContent sx={{ padding: { xs: 1, sm: 2 } }}>
            <Stack direction={"row"}>
              {/* <ArrowDownwardIcon sx={{ fontSize: "2rem" }} /> */}
              <GiLeg />
              <Typography>下半身</Typography>
            </Stack>
            <Typography
              variant="h5"
              sx={{
                textAlign: "right",
                fontWeight: "fontWeightBold",
                wordBreak: "break-word",
                fontSize: { xs: ".8rem", sm: "1rem", md: "1.2rem" },
              }}
            >
              {/* ¥{formatCurrency(expense)} */}
              {formatScore(lowerBody)}pt
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      {/* 有酸素 */}
      <Grid
        size={{ xs: 4 }}
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Card
          sx={{
            bgcolor: (theme) => theme.palette.cardio.main,
            color: "white",
            borderRadius: "10px",
            flexGrow: 1,
          }}
        >
          <CardContent sx={{ padding: { xs: 1, sm: 2 } }}>
            <Stack direction={"row"}>
              <FaRunning />
              <Typography>有酸素</Typography>
            </Stack>
            <Typography
              variant="h5"
              sx={{
                textAlign: "right",
                fontWeight: "fontWeightBold",
                wordBreak: "break-word",
                fontSize: { xs: ".8rem", sm: "1rem", md: "1.2rem" },
              }}
            >
              {/* ¥{formatCurrency(balance)} */}
              {formatScore(cardio)}pt
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default MonthlySummary;
